export const environment = {
  production: false,
  // backendUrl: 'http://192.168.1.64:3000',
  backendUrl: 'https://dev-meet.imsclouds.com',
  // backendUrl: 'http://localhost:3000',
  // backendUrl: 'https://rwfbxz80-3000.euw.devtunnels.ms',

  externalServer: 'https://dev-ims.intedgroup.com/api-v2/calling/webhook',
};
